var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoaderProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.2969,
    cy: 19.7656,
    r: 6.875,
    fill: "#E9EDF1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.2656,
    cy: 38.5,
    r: 7.73438,
    fill: "#DCE6EB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.6875,
    cy: 59.4688,
    r: 8.07812,
    fill: "#C8D2DC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.875,
    cy: 75.7969,
    r: 8.59375,
    fill: "#B9C3CD"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 78.8906,
    r: 9.10938,
    fill: "#A2ABB8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3594,
    cy: 66.6875,
    r: 9.45312,
    fill: "#909BA6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.96875,
    cy: 43.3125,
    r: 9.96875,
    fill: "#7E8B96"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7969,
    cy: 20.2812,
    r: 10.4844,
    fill: "#5F6C75"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5781,
    cy: 11,
    r: 11,
    fill: "#4E5A61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderProjects);
export default __webpack_public_path__ + "static/media/loader-projects.e2cb3235.svg";
export { ForwardRef as ReactComponent };